import React from 'react';
import AppHeader from '../../Components/Common/Layout/AppHeader';
import { StyledDiv } from '../../Theme/CommonStyled';
import Facture from '../../Components/Facture';
import { useLocation } from 'react-router-dom';

const FacturePage: React.FC = () => {
  const location = useLocation();
  return (
    <>
      <AppHeader
        title={'facture'}
        titleOption={{ number: location.state }}
        goBack
      />
      <StyledDiv
        id="notification-container"
        height={'calc(100vh - 60px)'}
        overflow={'auto'}>
        <Facture />
      </StyledDiv>
    </>
  );
};

export default FacturePage;
